import React from 'react';
import { observer } from 'mobx-react-lite';

import { globalTranslationKeys } from '../../../enums';

export const Timer = observer(({ time, duration, isBetsClosed }) => {
  return (
    <div className='mob-hex-circle-ins-svg'>
      {time !== null && (
        <svg
          className='hex-circle-chart'
          viewBox='0 0 33.83098862 33.83098862'
          width='100%'
          height='100%'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle
            className='circle-chart__background'
            stroke='#000000'
            strokeWidth='0.5'
            fill='none'
            cx='16.91549431'
            cy='16.91549431'
            r='15.91549431'
          />
          <circle
            className={`circle-chart__circle ${time || time === 0 ? 'anim' : ''}`}
            stroke='#ffbb00'
            strokeWidth='0.5'
            strokeDasharray='100'
            strokeDashoffset={-(100 - Math.floor((time / duration) * 100))}
            fill='none'
            cx='16.91549431'
            cy='16.91549431'
            r='15.91549431'
          />
        </svg>
      )}
      <div className='mob-hex-circle-timer'>
        {time === null && isBetsClosed ? globalTranslationKeys.GO : time}
      </div>
    </div>
  );
});
